// pages/ProductCreate.js
import React, { useState } from 'react';
import { FaArrowLeft, FaImage, FaUpload, FaTag, FaRupeeSign, FaFileAlt } from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';
import SummaryApi from '../common';
import { toast } from 'react-toastify';

const ProductCreate = () => {
  const [loading, setLoading] = useState(false);
  const [product, setProduct] = useState({
  product_name: '',
  product_description: '',
  price: '',
  product_img1: null,
  product_img2: null,
  product_code: '',
  sub_title: '',
  specifications: '',
  discount: '',
  after_discount_price: '',
  rating: '', 
  is_active: true, 
});

  
  const navigate = useNavigate();

const handleSubmit = async (e) => {
  e.preventDefault();

  // Validation first
  if (!product.product_name.trim()) {
    toast.error('Product name is required');
    return;
  }
  if (!product.product_description.trim()) {
    toast.error('Product description is required');
    return;
  }
  if (!product.price || parseFloat(product.price) <= 0) {
    toast.error('Valid price is required');
    return;
  }
  if (!product.product_img1) {
    toast.error('Product image is required');
    return;
  }

  setLoading(true);

  try {
    // Create FormData **here**, inside try
    const formData = new FormData();

    // Required fields
    formData.append('product_name', product.product_name);
    formData.append('product_description', product.product_description);
    formData.append('price', product.price);

    // Optional
    if (product.sub_title) formData.append('sub_title', product.sub_title);
    if (product.specifications) formData.append('specifications', product.specifications);
    if (product.discount) formData.append('discount', product.discount);
    if (product.after_discount_price) formData.append('after_discount_price', product.after_discount_price);

    // Images
    if (product.product_img1 instanceof File) {
      formData.append('product_img1', product.product_img1);
    }
    if (product.product_img2 instanceof File) {
      formData.append('product_img2', product.product_img2);
    }

    // Rating & Active
    if (product.rating) formData.append('rating', product.rating);
    formData.append('is_active', product.is_active ? '1' : '0');

    // Make API call
    const response = await fetch(SummaryApi.product.create.url, {
      method: SummaryApi.product.create.method,
      headers: {
        'Authorization': `Bearer ${SummaryApi.bearerToken}`,
      },
      body: formData,
    });

    const data = await response.json();

    if (data.success || data.status) {
      toast.success(data.message || 'Product created successfully!');
      navigate('/products');
    } else {
      toast.error(data.message || 'Failed to create product');
    }
  } catch (error) {
    console.error('Error creating product:', error);
    toast.error('Failed to create product');
  } finally {
    setLoading(false);
  }
};


  const handleImageUpload = (e, fieldName) => {
    const file = e.target.files[0];
    if (file) {
      if (file.size > 5 * 1024 * 1024) { // 5MB limit
        toast.error('Image size should be less than 5MB');
        return;
      }
      setProduct({...product, [fieldName]: file});
    }
  };

  const calculateAfterDiscount = () => {
    if (product.price && product.discount) {
      const price = parseFloat(product.price);
      const discount = parseFloat(product.discount);
      const afterDiscount = price - (price * discount / 100);
      setProduct({...product, after_discount_price: afterDiscount.toFixed(2)});
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-50 to-blue-50 p-6">
      <div className="max-w-4xl mx-auto">
        {/* Header */}
        <div className="mb-8">
          <button
            onClick={() => navigate('/products')}
            className="flex items-center text-blue-600 hover:text-blue-800 mb-4 transition-colors"
          >
            <FaArrowLeft className="mr-2" /> Back to Products
          </button>
          <h1 className="text-3xl font-bold text-gray-800">Create New Product</h1>
          <p className="text-gray-600 mt-2">Add a new product to your catalog</p>
        </div>

        {/* Form */}
        <div className="bg-white rounded-2xl shadow-xl p-8">
          <form onSubmit={handleSubmit}>
            <div className="space-y-6">
              {/* Product Name */}
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  <span className="flex items-center"><FaTag className="mr-2" /> Product Name *</span>
                </label>
                <input
                  type="text"
                  value={product.product_name}
                  onChange={(e) => setProduct({...product, product_name: e.target.value})}
                  className="w-full px-4 py-3 border border-gray-300 rounded-xl focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all"
                  placeholder="Enter product name"
                  required
                />
              </div>

              {/* Sub Title */}
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Sub Title (Optional)
                </label>
                <input
                  type="text"
                  value={product.sub_title}
                  onChange={(e) => setProduct({...product, sub_title: e.target.value})}
                  className="w-full px-4 py-3 border border-gray-300 rounded-xl focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                  placeholder="Enter product subtitle"
                />
              </div>

              {/* Product Code */}
              {/* <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Product Code (Optional)
                </label>
                <input
                  type="text"
                  value={product.product_code}
                  onChange={(e) => setProduct({...product, product_code: e.target.value})}
                  className="w-full px-4 py-3 border border-gray-300 rounded-xl focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                  placeholder="Enter product code"
                />
              </div> */}

              {/* Price and Discount */}
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    <span className="flex items-center"><FaRupeeSign className="mr-2" /> Price (₹) *</span>
                  </label>
                  <input
                    type="number"
                    value={product.price}
                    onChange={(e) => setProduct({...product, price: e.target.value})}
                    onBlur={calculateAfterDiscount}
                    className="w-full px-4 py-3 border border-gray-300 rounded-xl focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                    placeholder="Enter price"
                    required
                    min="1"
                  />
                </div>
                
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    Discount (%) (Optional)
                  </label>
                  <input
                    type="number"
                    value={product.discount}
                    onChange={(e) => setProduct({...product, discount: e.target.value})}
                    onBlur={calculateAfterDiscount}
                    className="w-full px-4 py-3 border border-gray-300 rounded-xl focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                    placeholder="Enter discount percentage"
                    min="0"
                    max="100"
                  />
                </div>
              </div>

              {/* Final Price */}
              {product.after_discount_price && (
                <div className="bg-blue-50 border border-blue-200 rounded-xl p-4">
                  <label className="block text-sm font-medium text-blue-700 mb-2">
                    Final Price After Discount
                  </label>
                  <div className="text-2xl font-bold text-blue-600">
                    ₹ {product.after_discount_price}
                  </div>
                </div>
              )}

              {/* Description */}
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  <span className="flex items-center"><FaFileAlt className="mr-2" /> Description *</span>
                </label>
                <textarea
                  value={product.product_description}
                  onChange={(e) => setProduct({...product, product_description: e.target.value})}
                  className="w-full px-4 py-3 border border-gray-300 rounded-xl focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                  placeholder="Enter detailed product description"
                  rows="4"
                  required
                />
              </div>

              {/* Specifications */}
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Specifications (Optional)
                </label>
                <textarea
                  value={product.specifications}
                  onChange={(e) => setProduct({...product, specifications: e.target.value})}
                  className="w-full px-4 py-3 border border-gray-300 rounded-xl focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                  placeholder="Enter product specifications (one per line)"
                  rows="3"
                />
              </div>
              

              {/* Product Images */}
              <div className="space-y-6">
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    <span className="flex items-center"><FaImage className="mr-2" /> Product Image 1 *</span>
                  </label>
                  <div className="border-2 border-dashed border-gray-300 rounded-xl p-8 text-center hover:border-blue-400 transition-colors">
                    <input
                      type="file"
                      accept="image/*"
                      onChange={(e) => handleImageUpload(e, 'product_img1')}
                      className="hidden"
                      id="product_img1"
                      required
                    />
                    <label
                      htmlFor="product_img1"
                      className="cursor-pointer block"
                    >
                      {product.product_img1 ? (
                        <div className="text-green-600">
                          <FaUpload className="mx-auto text-3xl mb-2" />
                          <span className="font-medium">Image Selected</span>
                          <p className="text-sm text-gray-500 mt-1">{product.product_img1.name}</p>
                        </div>
                      ) : (
                        <div className="text-gray-400">
                          <FaUpload className="mx-auto text-3xl mb-2" />
                          <span className="font-medium">Click to upload image</span>
                          <p className="text-sm text-gray-500 mt-1">PNG, JPG, JPEG up to 5MB</p>
                        </div>
                      )}
                    </label>
                  </div>
                </div>

                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    <span className="flex items-center"><FaImage className="mr-2" /> Product Image 2 (Optional)</span>
                  </label>
                  <div className="border-2 border-dashed border-gray-300 rounded-xl p-8 text-center hover:border-blue-400 transition-colors">
                    <input
                      type="file"
                      accept="image/*"
                      onChange={(e) => handleImageUpload(e, 'product_img2')}
                      className="hidden"
                      id="product_img2"
                    />
                    <label
                      htmlFor="product_img2"
                      className="cursor-pointer block"
                    >
                      {product.product_img2 ? (
                        <div className="text-green-600">
                          <FaUpload className="mx-auto text-3xl mb-2" />
                          <span className="font-medium">Image Selected</span>
                          <p className="text-sm text-gray-500 mt-1">{product.product_img2.name}</p>
                        </div>
                      ) : (
                        <div className="text-gray-400">
                          <FaUpload className="mx-auto text-3xl mb-2" />
                          <span className="font-medium">Click to upload second image</span>
                          <p className="text-sm text-gray-500 mt-1">Optional additional image</p>
                        </div>
                      )}
                    </label>
                  </div>
                </div>
              </div>
{/* Rating */}
<div>
  <label className="block text-sm font-medium text-gray-700 mb-2">
    Rating (Optional)
  </label>
  <input
    type="number"
    min="0"
    max="5"
    step="0.1"
    value={product.rating}
    onChange={(e) => setProduct({...product, rating: e.target.value})}
    className="w-full px-4 py-3 border border-gray-300 rounded-xl focus:ring-2 focus:ring-blue-500 focus:border-transparent"
    placeholder="Enter product rating (0 to 5)"
  />
</div>

{/* Active Toggle */}
<div className="flex items-center space-x-3">
  <label className="block text-sm font-medium text-gray-700">Active Status</label>
  <input
    type="checkbox"
    checked={product.is_active}
    onChange={(e) => setProduct({...product, is_active: e.target.checked})}
    className="h-5 w-10 rounded-full cursor-pointer transition-colors duration-200 accent-green-500"
  />
  <span className={`text-sm font-medium ${product.is_active ? 'text-green-600' : 'text-red-600'}`}>
    {product.is_active ? 'Active' : 'Inactive'}
  </span>
</div>


              {/* Form Actions */}
              <div className="flex justify-end space-x-4 pt-6 border-t border-gray-200">
                <button
                  type="button"
                  onClick={() => navigate('/products')}
                  className="px-8 py-3 border border-gray-300 text-gray-700 rounded-xl hover:bg-gray-50 transition-colors duration-200 font-medium"
                  disabled={loading}
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  disabled={loading}
                  className="px-8 py-3 bg-gradient-to-r from-green-500 to-green-600 hover:from-green-600 hover:to-green-700 text-white rounded-xl font-medium shadow-lg hover:shadow-xl transition-all duration-200 disabled:opacity-70 disabled:cursor-not-allowed"
                >
                  {loading ? (
                    <span className="flex items-center">
                      <svg className="animate-spin -ml-1 mr-3 h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                        <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                        <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                      </svg>
                      Creating Product...
                    </span>
                  ) : (
                    'Create Product'
                  )}
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default ProductCreate;